export default [
  {
    path: 'watermark',
    name: 'website.watermark',
    component: () => import('@/views/website/watermark'),
  },
];
